import * as fetchAPI from '@/components/fetchService';
import * as constants from '@/constants';
import { AutoCompleteParams, SearchParams } from './data';
import { notification } from 'antd';

export async function autocomplete(params: AutoCompleteParams) {
  const res: any[] = [];
  const queryURL = '/igj_toezicht/api/submissions/';

  if (params.search.length >= 3) {
    const result: any = await fetchAPI.fetchAPIPOST(queryURL, { ...params, display_lang: 'en' });

    if (result && result.status === 200) {
      result.value.forEach((i: any) => {
        res.push(i);
      });
    } else {
      notification.error({
        message: 'Error while suggesting IGJ toezicht records',
      });
      return null;
    }
  }

  return res
    .filter(
      (obj, pos, arr) =>
        arr.map(mapObj => mapObj['@search.text']).indexOf(obj['@search.text']) === pos,
    )
    .slice(0, constants.AutoCompleteRes);
}

export async function igjToezichtSearch(params: SearchParams) {
  return fetchAPI.fetchAPIPOST('/igj_toezicht/api/submission_search/', { ...params, display_lang: 'en' });
}

export async function fetchIgjToezichtFilters() {
  return fetchAPI.fetchAPIGET('/igj_toezicht/api/filters/');
}
